
import { useState, useRef, useEffect } from 'react'
import { inject, observer } from 'mobx-react';
import { createMultipleRef, getValueInputRef } from '../../../helpers'
import { Input, Modal, ModalAlert, Select, FormLoading } from '../../../components'
import { CauseReasonService } from '../../../services';
import { isEmpty, get } from 'lodash'
import { useTranslation } from 'react-i18next'

const ModalReason = inject("causeReasonStore")(observer((props) => {
  const { t } = useTranslation(['cause-reason', 'common'])
  let causeReasonStore = props.causeReasonStore
  let { getOpenReason, getDataReasonEdit, setCauseStore } = causeReasonStore // ACTIONS

  let { masterOptions, open, data, auth } = props // STATES
  let { onReload } = props // ACTIONS

  const [loading, setLoading]: any = useState({ visible: false, tip: 'saving' })
  const [openModal, setOpenModal]: any = useState(false)
  const [validation, setValidation]: any = useState({})
  const [shakeIsWrong, setShakeIsWrong] = useState(false)
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: []
    }
  })

  const [dataForm, setDataForm]: any = useState({
    "mode": "add",
    "cause_id": "",
    "reason_id": "",
    "reason_name": "",
    "status": "Y"
  })

  const inputRef: any = useRef([]);
  createMultipleRef(inputRef, 1)

  useEffect(() => {
    let data = getDataReasonEdit
    if (!isEmpty(data)) {
      let dataForm = {}
      if (get(data, 'cause_id')) {
        dataForm = {
          "mode": "add",
          "cause_id": data?.cause_id,
          "reason_id": "",
          "reason_name": "",
          "status": "Y"
        }
      }
      else {
        dataForm = {
          "mode": "update",
          "reason_id": data?.reason_id,
          "reason_name": data?.reason_name,
          "status": data?.reason_status
        }
      }

      setDataForm(dataForm)
    }
    setOpenModal(getOpenReason)

  }, [getOpenReason, getDataReasonEdit])

  const initialData = () => {
    setValidation({})
    setDataForm({
      "mode": "add",
      "cause_id": "",
      "reason_id": "",
      "reason_name": "",
      "status": "Y"
    })
  }

  const onSave = () => {
    let validateCheck = {}, message = { isError: true, message: "โปรดระบุ" }
    let formData = getValueInputRef(inputRef)

    if (formData.reason_name.trim() === "")
      validateCheck['reason_name'] = message
    if (dataForm.status.length === 0 || dataForm.status === "")
      validateCheck['status'] = message

    if (isEmpty(validateCheck)) {
      setValidation({})
      setOptionAlert({
        ...optionAlert,
        action: {
          id: dataForm.id,
          name: "save"
        },
        type: "confirm",
        title: t('common:confirm'),
        show: true,
        description: {
          visible: true,
          type: "text",
          content: t('common:save_the_data'),
          contentLists: []
        }
      })
    }
    else {
      setValidation(validateCheck)
      setShakeIsWrong(true)
      setTimeout(() => setShakeIsWrong(false), 100);
    }
  }

  const saveData = () => {
    let formData = getValueInputRef(inputRef)
    let data: any = {
      "reason_name": formData.reason_name,
      "status": dataForm.status
    }

    if (dataForm.mode === "update") {
      data.reason_id = dataForm?.reason_id
    }
    else {
      data.cause_id = dataForm?.cause_id
    }
    setLoading({ ...loading, visible: true, tip: 'saving' })
    if (dataForm.mode === "add") {
      CauseReasonService.addReason(auth, data)
        .then((res: any) => {
          let { code, message, sys_message } = res.data

          if (code === 200) {
            setOptionAlert({
              ...optionAlert,
              type: "success",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: t('common:saved_successfully'),
              description: { visible: false, type: "text", content: " ", contentLists: [] }
            })
            initialData()
            onReload()
            onCloseModal()
          }
          else {
            setOptionAlert({
              ...optionAlert,
              type: "danger",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: "ผิดพลาด",
              description: { visible: true, type: "text", content: `${message} ${sys_message}` }
            })
          }
          setLoading({ ...loading, visible: false })
        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${err}` }
          })
          setLoading({ ...loading, visible: false })
        })
    }
    else {
      CauseReasonService.updateReason(auth, data)
        .then((res: any) => {
          let { code, message, sys_message } = res.data

          if (code === 200) {
            setOptionAlert({
              ...optionAlert,
              type: "success",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: t('common:saved_successfully'),
              description: { visible: false, type: "text", content: " ", contentLists: [] }
            })
            initialData()
            onReload()
            onCloseModal()
          }
          else {
            setOptionAlert({
              ...optionAlert,
              type: "danger",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: "ผิดพลาด",
              description: { visible: true, type: "text", content: `${message} ${sys_message}` }
            })
          }
          setLoading({ ...loading, visible: false })
        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${err}` }
          })
          setLoading({ ...loading, visible: false })
        })
    }
  }

  const onCloseModal = () => setCauseStore({ openReason: false, dataReasonEdit: {} })

  return (<>
    {
      openModal && <Modal
        title={{ text: `${dataForm.mode === "add" ? t('add_cause') : t('edit_cause')}` }}
        open={true}
        maskClosable={true}
        shake={shakeIsWrong}
        onClosed={() => {
          onCloseModal()
          initialData()
        }}
        onOk={() => onSave()}
      >
        <FormLoading loading={loading.visible} tip={loading.tip}>
          <div className="flex flex-col space-y-2">
            <div className='flex-1'>
              <Input
                id="reason_name"
                label={t('cause')}
                placeholder={t('cause')}
                required={true}
                defaultValue={dataForm.reason_name}
                validate={validation?.reason_name}
                onRef={(ref) => inputRef.current[0] = ref}
              />
            </div>

            <div className='flex-1'>
              <Select
                label={t('status')}
                placeholder={t('status')}
                required={true}
                onChange={(select) => setDataForm({ ...dataForm, status: select })}
                defaultValue={dataForm.status}
                validate={validation?.status}
                options={masterOptions.common_status}
              />
            </div>
          </div>
        </FormLoading>
      </Modal>}


    <ModalAlert
      {...optionAlert}
      onOk={() => {
        let { action } = optionAlert
        if (action.name === "save") saveData()
        setOptionAlert({ ...optionAlert, show: false })
      }}
      onCancel={() => {
        setOptionAlert({ ...optionAlert, show: false })
      }}
    />
  </>
  )
}))

export default ModalReason